// extracted by mini-css-extract-plugin
export default {"table":"Customers_table__BLRRM","container":"Customers_container__El6PI","inputSearchContainer":"Customers_inputSearchContainer__L3--i"};